<template>
  <div class="m-field m-field_datetime">
    <label class="m-field__label" for="datetimeInput"
      >Выберите дату и время (МСК):</label
    >
    <input
      class="a-input"
      type="datetime-local"
      id="datetimeInput"
      ref="datetimeInput"
      :value="value | humanDate"
      :placeholder="placeholderDateTime"
      @input="changeDateTime"
    />
  </div>
</template>

<script>
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import { Russian } from "flatpickr/dist/l10n/ru.js";

export default {
  data() {
    return {
      selectedDateTime: "",
      flt: undefined,
      di: undefined,
    };
  },
  props: ["value"],
  watch: {
    value() {
      this.$nextTick(() => {
        if (this.flt) {
          this.flt.setDate(this.value);
        }
      });
    },
  },
  filters: {
    // eslint-disable-next-line no-unused-vars
    humanDate(val) {
      if (val && val.includes("Z")) {
        return `${new Date(val).toLocaleDateString()} ${new Date(val)
          .toLocaleTimeString()
          .split(":")
          .splice(0, 2)
          .join(":")}`;
      } else return val;
    },
  },
  computed: {
    placeholderDateTime: function () {
      return `${new Date(
        Date.now() + 5 * 1000 * 60
      ).toLocaleDateString()} ${new Date(Date.now() + 5 * 1000 * 60)
        .toLocaleTimeString()
        .split(":")
        .splice(0, 2)
        .join(":")}`;
    },
  },
  mounted() {
    this.flt = flatpickr(this.$refs.datetimeInput, {
      time_24hr: true,
      locale: Russian,
      minDate: new Date(Date.now() + 5 * 60 * 1000),
      dateFormat: "d.m.Y H:i",
      enableTime: true,
      minTime: "09:00",
      maxTime: "21:00",
      onReady: function (selectedDates, dateStr, instance) {
        const hourInput = instance.hourElement;
        const minuteInput = instance.minuteElement;
        hourInput.setAttribute("readonly", "readonly");
        minuteInput.setAttribute("readonly", "readonly");
      },
    });
    if (this.di) clearInterval(this.di);
    this.di = setInterval(() => {
      this.changeDateTime({
        target: { value: this.hd(this.value) },
      });
    }, 1000 * 60);
  },
  methods: {
    hd(val) {
      if (val && val.includes("Z")) {
        return `${new Date(val).toLocaleDateString()} ${new Date(val)
          .toLocaleTimeString()
          .split(":")
          .splice(0, 2)
          .join(":")}`;
      } else return val;
    },
    changeDateTime(value) {
      const v = value.target.value;
      const [d, t] = v.split(" ");
      const [day, month, year] = d.split(".");
      const [h, m] = t.split(":");
      const date = new Date(year, month - 1, day, h, m);
      const nearestDate = new Date(Date.now() + 5 * 1000 * 60);
      if (date < nearestDate) {
        this.$emit("input", this.hd(nearestDate.toISOString()));
        if (this.flt) {
          this.flt.setDate(this.hd(nearestDate.toISOString()));
        }
      } else {
        this.$emit("input", value.target.value);
      }
    },
  },
};
</script>

<style>
.flatpickr-day.selected {
  border-color: #0081bd;
  background: #0081bd;
}

.flatpickr-day.selected:hover {
  border-color: #0081bd;
  background: #0081bd;
}

.flatpickr-day.selected:focus {
  border-color: #0081bd;
  background: #0081bd;
}

.a-input {
  font-family: Font-Light, Arial, sans-serif;
  font-size: 16px;
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #0081bd;
}

.flatpickr-day.today {
  border-color: #0081bd;
}

.flatpickr-day.today:hover {
  border-color: #0081bd;
  background: #0081bd;
  color: #ffffff;
}

.flatpickr-day.selected.nextMonthDay {
  background: #0081bd;
  border-color: #0081bd;
}

.flatpickr-day {
  font-family: Font-Light, Arial, sans-serif;
}

.flatpickr-time input.flatpickr-hour {
  font-family: Font-Regular, Arial, sans-serif;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  font-family: Font-Raleway-Regular, Arial, sans-serif;
  color: #000000;
  font-weight: bold;
  font-size: 1rem;
}

.flatpickr-current-month input.cur-year {
  font-family: Font-Light, Arial, sans-serif;
  color: #000000;
  font-size: 1rem;
}

.flatpickr-weekdaycontainer span.flatpickr-weekday {
  font-family: Font-Light, Arial, sans-serif;
}

.numInput {
  cursor: default;
}
</style>
